import React from 'react';

export function ExecutePlanIcon({ color }: { color: 'blue' | 'gray' | 'white' }) {
  const fill = color === 'blue' ? '#2563EB' : color === 'white' ? '#FFFFFF' : '#9CA3AF';
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_26272_211930)">
        <path
          d="M0.824805 5.60041C0.949805 5.67541 1.0998 5.72541 1.2248 5.72541C1.3498 5.72541 1.4998 5.70041 1.6248 5.62541L4.8248 3.87541C5.0748 3.72541 5.2498 3.47541 5.2498 3.17541C5.2498 2.87541 5.0998 2.60041 4.8248 2.47541L1.6248 0.725408C1.3748 0.575408 1.0748 0.600408 0.824805 0.725408C0.574805 0.875408 0.424805 1.12541 0.424805 1.42541V4.95041C0.449805 5.17541 0.574805 5.45041 0.824805 5.60041ZM1.5748 1.92541L3.7748 3.15041L1.5748 4.37541V1.92541Z"
          fill={fill}
        />
        <path
          d="M14.9996 4.0752H7.67461C7.37461 4.0752 7.09961 4.3252 7.09961 4.6502C7.09961 4.9752 7.34961 5.2252 7.67461 5.2252H14.9996C15.2996 5.2252 15.5746 4.9752 15.5746 4.6502C15.5746 4.3252 15.2996 4.0752 14.9996 4.0752Z"
          fill={fill}
        />
        <path
          d="M7.67461 1.7252H14.9996C15.2996 1.7252 15.5746 1.4752 15.5746 1.1502C15.5746 0.825195 15.3246 0.575195 14.9996 0.575195H7.67461C7.37461 0.575195 7.09961 0.825195 7.09961 1.1502C7.09961 1.4752 7.37461 1.7252 7.67461 1.7252Z"
          fill={fill}
        />
        <path
          d="M14.9748 7.55029H0.999805C0.699805 7.55029 0.424805 7.80029 0.424805 8.12529C0.424805 8.45029 0.674805 8.67529 0.999805 8.67529H14.9748C15.2748 8.67529 15.5498 8.42529 15.5498 8.12529C15.5498 7.82529 15.2748 7.55029 14.9748 7.55029Z"
          fill={fill}
        />
        <path
          d="M14.9748 11H0.999805C0.699805 11 0.424805 11.25 0.424805 11.575C0.424805 11.9 0.674805 12.15 0.999805 12.15H14.9748C15.2748 12.15 15.5498 11.9 15.5498 11.575C15.5498 11.25 15.2748 11 14.9748 11Z"
          fill={fill}
        />
        <path
          d="M14.9748 14.4751H0.999805C0.699805 14.4751 0.424805 14.7251 0.424805 15.0501C0.424805 15.3751 0.674805 15.6251 0.999805 15.6251H14.9748C15.2748 15.6251 15.5498 15.3751 15.5498 15.0501C15.5498 14.7251 15.2748 14.4751 14.9748 14.4751Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_26272_211930">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
